module.exports = __webpack_public_path__ + "static/media/reports-icon.3f171261.svg";